import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { useCallback } from 'react';

export const useCopyToClipboard = () => {
  const { showSuccessNotification } = useNotificationContext();

  const copyTextToClipboard = useCallback(
    (text: string, toastText?: string) => {
      navigator.clipboard.writeText(text);

      showSuccessNotification({
        contentComponent: toastText ?? 'Copied to Clipboard',
        props: {},
      });
    },
    [showSuccessNotification],
  );

  return copyTextToClipboard;
};
